class MediaQuery {
  constructor() {
    this.head = document.getElementsByTagName("head")[0];
    this.title = document.getElementsByTagName("title")[0];
    this.key = "procore.viewportchange";
    const breakpointsString = window.getComputedStyle(this.head)["font-family"];
    const currentBreakpointString = window.getComputedStyle(this.title)["font-family"];
    this.breakpoints = this.parseCssProperty(breakpointsString);
    this.currentBreakpoint = this.parseCssProperty(currentBreakpointString);

    this.buildMatchMediaList();
  }

  parseCssProperty(str) {
    const formated = str.replace(/^('|")|(\\)|('|")$/g, "");
    const trimed = formated.trim();
    const parsed = JSON.parse(trimed);

    return parsed;
  }

  //   getBreakpointValue(breakpoint) {
  //     let value = 0;

  //     if (typeof this.breakpoints[breakpoint] !== "undefined") {
  //       value = parseInt(this.breakpoints[breakpoint], 10);
  //     } else {
  //       throw 'Breakpoint not found: "' + breakpoint + '"';
  //     }

  //     return value;
  //   }

  //   query(options) {
  //     var breakpointFrom,
  //       breakpointTo,
  //       breakpointCurrent = parseInt(this.currentBreakpoint.value, 10);

  //     if (typeof options !== "object") {
  //       // No or wrong arguments passed
  //       throw 'Illegal argument of type "' +
  //         typeof options +
  //         '", expected "object"';
  //     } else if (
  //       typeof options.to !== "undefined" &&
  //       typeof options.from !== "undefined"
  //     ) {
  //       breakpointFrom = this.getBreakpointValue(options.from);
  //       breakpointTo = this.getBreakpointValue(options.to);

  //       // "from" cannot be larger than "to"
  //       if (breakpointFrom > breakpointTo) {
  //         throw "Breakpoint " +
  //           breakpointFrom +
  //           " is larger than " +
  //           breakpointTo +
  //           "";
  //       }

  //       // The breakpoint needs to smaller than the "to" (exclusive)
  //       // but larger or the same as "from" (inclusive)
  //       return (
  //         breakpointFrom <= breakpointCurrent && breakpointCurrent < breakpointTo
  //       );
  //     } else if (typeof options.to !== "undefined") {
  //       breakpointTo = this.getBreakpointValue(options.to);

  //       // Breakpoint needs to smaller than the "to" (exclusive)
  //       return breakpointCurrent < breakpointTo;
  //     } else if (typeof options.from !== "undefined") {
  //       breakpointFrom = this.getBreakpointValue(options.from);

  //       // Breakpoint needs larger or the same as "from" (inclusive)
  //       return breakpointCurrent >= breakpointFrom;
  //     } else {
  //       throw 'No values for "to" or "from" received';
  //     }
  //   }

  //   /**
  //    * Based on breakpointCurrent pixel value return name of that breakpoint as string
  //    */
  //   getCurrentBreakpointName() {
  //     var ret,
  //       breakpointsNameArray = _.keys(this.breakpoints);

  //     breakpointsNameArray.forEach(
  //       function(breakpointName) {
  //         var queryResult = this.query({ from: breakpointName });

  //         if (queryResult) {
  //           ret = breakpointName;
  //         }
  //       }.bind(this)
  //     );

  //     return ret;
  //   }

  /**
   * triggers event
   */
  triggerBreakpointChange() {
    const currentBreakpointString = window.getComputedStyle(this.title)["font-family"];
    const breakpoint = this.parseCssProperty(currentBreakpointString),
      prevBreakpoint = this.currentBreakpoint;

    this.currentBreakpoint = breakpoint;

    // Define that the event name is 'build'.
    const event = new CustomEvent(this.key, {
      detail: { prevBreakpoint, breakpoint },
    });

    if (breakpoint.name !== prevBreakpoint.name) {
      document.dispatchEvent(event);
    }

    // this.dispatchEvent(this.key, [prevBreakpoint, breakpoint]);
  }

  /**
   * mql parameter is passed to query against different viewports
   */
  handleViewportSizeChange(mql) {
    this.triggerBreakpointChange(mql);
  }

  /**
   * Build queries list based on breakpoints array passed from css
   */
  buildMatchMediaList() {
    // Add listener for orientation change
    // mql = window.matchMedia('(orientation: landscape)');
    // mql.addListener(handleOrientationChange);

    Object.values(this.breakpoints).forEach((width) => {
      const query = "(min-width:" + width + ")";

      const mql = window.matchMedia(query);
      mql.addEventListener("change", this.handleViewportSizeChange.bind(this));
    });
  }
}

export { MediaQuery };
